import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { sessionStore } from "@/Globals/Stores/SessionStore";
import { AutomaticWorkflowStep } from "../../BaseWorkflow/Steps/AutomaticWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class LoadCacheStep extends AutomaticWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.LoadCache);
    }

    public isValid(): boolean {
        return !sessionStore.clientLoginModel.get("IsCacheLoaded");
    }

    public isCompleted(): boolean {
        return !!sessionStore.clientLoginModel.get("IsCacheLoaded");
    }

    public execute(): void {
        const isClinicalAccount = sessionStore.myleEmployeeType === EmployeeType.Practician;
        const hasPrescriptionRenewalsAccess = sessionStore.userPermissions.some(x => x === "PrescriptionRenewalTabPermission") && cacheStore.ClinicSettings?.EnablePrescriptionRenewal;
        cacheStore.RequestApplicationStringAsync(
            sessionStore.locale,
            () => {
                sessionStore.action.loadCache(isClinicalAccount || hasPrescriptionRenewalsAccess);

                sessionStore.toggleNavigationPrompt(true);

                if (sessionStore.debugSessionTicks) {
                    console.log("Session Timer Started");
                }
            }
        );
    }
}

export { LoadCacheStep };
